module.exports = __webpack_public_path__ + "img/google-play-badge_es.90ec3196.png";